module.exports = __webpack_public_path__ + "static/media/emojis2_19.d8569e10.svg";